import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePermission } from "../../../utils/commonfunction";

const UserManagementTabs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { can } = usePermission();

  const isUsersActive = location.pathname.includes("/customers");
  const isRejectedActive = location.pathname.includes("/streamers/rejected");
  const isPendingActive = location.pathname.includes("/streamers/pending");
  const isBusinessUsersActive = location.pathname.includes("/streamers/list") || (location.pathname.includes("/streamers") && !isRejectedActive && !isPendingActive);

  const [hoveredTab, setHoveredTab] = useState(null);

  const getLinkStyle = (isActive, tabId) => {
    const isHovered = hoveredTab === tabId;
    if (isActive) {
      return {
        backgroundColor: "#6259ca",
        color: "#ffffff",
        border: "1px solid #6259ca",
        padding: "8px 18px",
        fontWeight: "500",
        fontSize: "14px",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(98, 89, 202, 0.3)",
        transition: "all 0.2s ease",
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
      };
    }
    if (isHovered) {
      return {
        backgroundColor: "#6259ca",
        color: "#ffffff",
        border: "1px solid #6259ca",
        padding: "8px 18px",
        fontWeight: "500",
        fontSize: "14px",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(98, 89, 202, 0.25)",
        transition: "all 0.2s ease",
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
      };
    }
    return {
      backgroundColor: "#ffffff",
      color: "#4b5563",
      border: "1px solid #d1d5db",
      padding: "8px 18px",
      fontWeight: "500",
      fontSize: "14px",
      borderRadius: "5px",
      transition: "all 0.2s ease",
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
    };
  };

  return (
    <div className="nav_tab_container mb-4">
      <div className="d-flex align-items-center gap-2" role="tablist" style={{ flexWrap: "wrap" }}>
        {/* 1. Users Tab */}
        {(can("/admin/customers/list") || true) && (
          <Link
            to="/admin/customers/list/1"
            className="nav-link-custom"
            role="tab"
            style={getLinkStyle(isUsersActive, "users")}
            onMouseEnter={() => setHoveredTab("users")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <i
              className="fa fa-users"
              style={{
                color: (isUsersActive || hoveredTab === "users") ? "#ffffff" : "#6259ca",
                fontSize: "14px",
                transition: "color 0.2s ease",
              }}
            ></i>
            <span>Users</span>
          </Link>
        )}

        {/* 2. Business Users Tab */}
        {(can("/admin/streamers/list") || true) && (
          <Link
            to="/admin/streamers/list/1"
            className="nav-link-custom"
            role="tab"
            style={getLinkStyle(isBusinessUsersActive, "business_users")}
            onMouseEnter={() => setHoveredTab("business_users")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <i
              className="fa fa-briefcase"
              style={{
                color: (isBusinessUsersActive || hoveredTab === "business_users") ? "#ffffff" : "#6259ca",
                fontSize: "14px",
                transition: "color 0.2s ease",
              }}
            ></i>
            <span>Business Users</span>
          </Link>
        )}

        {/* 3. KYC Pending Tab */}
        {(can("/admin/streamers/list") || true) && (
          <Link
            to="/admin/streamers/pending/1"
            className="nav-link-custom"
            role="tab"
            style={getLinkStyle(isPendingActive, "pending_users")}
            onMouseEnter={() => setHoveredTab("pending_users")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <i
              className="fa fa-hourglass-half"
              style={{
                color: (isPendingActive || hoveredTab === "pending_users") ? "#ffffff" : "#f59e0b",
                fontSize: "14px",
                transition: "color 0.2s ease",
              }}
            ></i>
            <span>KYC Pending</span>
          </Link>
        )}

        {/* 4. Rejected Tab */}
        {(can("/admin/streamers/list") || true) && (
          <Link
            to="/admin/streamers/rejected/1"
            className="nav-link-custom"
            role="tab"
            style={getLinkStyle(isRejectedActive, "rejected_users")}
            onMouseEnter={() => setHoveredTab("rejected_users")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <i
              className="fa fa-user-times"
              style={{
                color: (isRejectedActive || hoveredTab === "rejected_users") ? "#ffffff" : "#dc2626",
                fontSize: "14px",
                transition: "color 0.2s ease",
              }}
            ></i>
            <span>Rejected</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default UserManagementTabs;

